/** Move observer-driven layout work out of ResizeObserver delivery. */
export function createAnimationFrameTask(task: () => void) {
  let frame: number | null = null;
  let disposed = false;
  return {
    schedule() {
      if (disposed || frame !== null) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        if (!disposed) task();
      });
    },
    dispose() {
      disposed = true;
      if (frame !== null) window.cancelAnimationFrame(frame);
      frame = null;
    },
  };
}

export function observeElementHeight(element: HTMLElement, onHeight: (height: number) => void) {
  let height = 0;
  const measure = () => {
    const next = Math.ceil(element.getBoundingClientRect().height);
    if (next > 0 && next !== height) {
      height = next;
      onHeight(next);
    }
  };
  measure();
  const frame = createAnimationFrameTask(measure);
  const observer = new ResizeObserver(frame.schedule);
  observer.observe(element);
  return () => {
    observer.disconnect();
    frame.dispose();
  };
}
